import {Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-phone-info-item',
    templateUrl: './phone-info-item.component.html',
    styleUrls: ['./phone-info-item.component.css'],
    imports: [TranslateModule]
})
export class PhoneInfoItemComponent {
  @Input() phoneNumber
}
